import styled from 'styled-components';
import CustomTable from '../CustomTable';
import TextBox from 'components/TextBox';
import { IToken } from 'store/ducks/globalTypes';
import { Button, Input } from 'antd';
import { ITextBoxProps } from 'store/ducks/Tasks/types';

const { TextArea } = Input;

export const StyledCustomTable = styled(CustomTable)<IToken>`
  .ant-table-row-expand-icon-cell {
    display: none;
  }

  .ant-table-cell:last-child {
    &:before {
      position: absolute;
      top: 50%;
      inset-inline-end: 0;
      width: 1px;
      height: 1.6em;
      background-color: ${(props) => props.token.colorBgMask};
      transform: translateY(-50%);
      transition: background-color 0.2s;
      content: '';
      display: block;
    }
  }

  .ant-table-row-level-0 {
    > .ant-table-cell {
      padding: 0 16px;

      &:before {
        display: none;
      }

      > div {
        padding: 0 16px;
      }
    }
  }

  .ant-table-wrapper {
    .ant-table {
      margin: unset !important;
    }
  }

  .ant-spin-nested-loading {
    overflow-y: initial !important;
  }
`;

export const AuditsContainer = styled('div')<ITextBoxProps>`
  padding: unset !important;

  > div {
    margin-bottom: ${(props) => `${props.token.marginMD}px`};

    :last-child {
      margin: 0;
    }
  }
`;

export const StyledTextBox = styled(TextBox)<ITextBoxProps>`
  background: ${(props) =>
    props.children ? props.token.colorFillContent : 'transparent'};
`;

export const StyledButton = styled(Button)<IToken>`
  border: unset;
  margin-bottom: 5px;
  min-width: 24px;
  border-radius: 50%;
  padding: 0;
  width: 24px !important;
  height: 24px;
  align-self: flex-end;
  margin-left: 6px;
`;

export const StyledAssignedFindings = styled('div')`
  display: flex;
`;

export const StyledDeleteDiv = styled('div')`
  display: flex;
`;

export const CategoryContainer = styled('div')<{ hasAudits: boolean }>`
  margin-left: ${(props) => (props.hasAudits ? '-30px' : '-50px')} !important;
  position: relative;
`;

export const AlignedAuditFindingsContainer = styled('div')`
  margin-left: -30px !important;
`;

export const ClientReqTextArea = styled(TextArea)<{
  level?: number;
  width?: number;
  scheme?: string;
}>`
  width: ${({ width = 445 }) => width}px;
  padding-left: 20px;
  resize: both !important;

  ${(props) =>
    props.scheme === 'darkUITheme' ||
    props.scheme === 'bluishTheme' ||
    props.scheme === 'deepBlueTheme' ||
    props.scheme === 'deepNavyTheme'
      ? 'color: #000000 !important;'
      : ''}

  /* Base sizes */
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: linear-gradient(135deg, #f3f3f3, #dadada);
    border-radius: 10px;
    box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.15);
  }

  /* Thumb */
  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #8aa0b8, #6e8299);
    border-radius: 10px;
    border: 2px solid #f3f3f3; /* gives a "pill" shape cutout */
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    transition: background 0.2s ease, box-shadow 0.2s ease;
  }

  /* Hover state */
  &::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #7e95af, #5e738c);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);
  }

  /* Active state */
  &::-webkit-scrollbar-thumb:active {
    background: linear-gradient(135deg, #6c84a0, #4f637a);
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #6e8299 #dadada;
`;
